<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="pageConfig.title"
    [isForm]="true"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
    [showRefreshBtn]="false"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <div class="row">
      <!-- col 1 mobile-->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <!-- mobile -->
        <list-group-item label="common.mobile" [value]="model?.mobile">
          <i
            icon
            class="mdi mdi-cellphone tw-text-gray-700 dark:tw-text-gray-300 tw-ml-2 tw-mb-2 mdi-20px"
          ></i>
        </list-group-item>
      </div>

      <!-- col 2 mobileOperator -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="'common.operator'"
          [value]="model?.mobileOperator | enumToText : SmsAggregatorEnumValues"
        >
          <i
            icon
            class="mdi mdi-sim tw-text-gray-700 dark:tw-text-gray-300 tw-ml-2 tw-mb-2 mdi-20px"
          ></i>
        </list-group-item>
      </div>

      <!-- col 3  created -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item [label]="'common.createDate'" [isShowValue]="false">
          <div
            class="badge badge-light border dir-ltr tw-text-gray-800 tw-text-[13px] text-wrap"
            content
          >
            <span class="dir-ltr">
              {{
                model?.created
                  | dateTimeWithSecondConvertor
                    : translationService.currentLang() || "fa"
              }}
            </span>
          </div>
          <i
            icon
            class="mdi mdi-calendar tw-text-gray-700 dark:tw-text-gray-300 tw-ml-2 tw-mb-1 mdi-20px"
          ></i>
        </list-group-item>
      </div>
    </div>

    <!-- ShowPhonebookReceivers -->
    <div
      class="row tw-justify-center tw-mt-3"
      *ngIf="model?.fieldResponses.length > 0"
    >
      <div class="tw-w-full">
        <h5 class="tw-mr-2 tw-my-4 tw-text-gray-700 dark:tw-text-gray-200">
          {{ "common.responses" | translate }}
        </h5>
        <app-dynamic-table
          [config]="pageConfig?.tableConfig"
          [loading]="false"
          [isEmpty]="pageConfig?.isEmpty"
          [hasError]="pageConfig?.hasError"
          (sortObject)="getSortItems($event)"
          (comparisonObjects)="getComparisonObjects($event)"
          (pageNumber)="changePageNumber($event)"
          (pageSize)="changePageSize($event)"
        >
          <ng-container
            table-body
            *ngIf="model?.fieldResponses && !pageConfig.loading"
          >
            <ng-container
              *ngFor="let item of model?.fieldResponses; let i = index"
            >
              <tr>
                <!-- index -->
                <td class="tw-text-center !tw-p-4">
                  {{ paginationModel?.firstIndex + i }}
                </td>

                <!-- formBuilderFieldTitle -->
                <td>
                  <td-value
                    copyToClipboard
                    class="tw-font-semibold"
                    copyToClipboard
                    [value]="item?.formBuilderFieldTitle"
                  ></td-value>
                </td>

                <!-- fieldType -->
                <td>
                  <span>{{
                    item?.fieldType
                      | enumToText : FormBuilderFieldTypesEnumValues
                  }}</span>
                </td>

                <!-- response -->
                <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
                  <td-value
                    class="tw-font-bold text-dark"
                    [type]="
                      item?.fieldType == FormBuilderFieldTypes.Date
                        ? 'date'
                        : 'text'
                    "
                    [value]="item?.response"
                  ></td-value>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </app-dynamic-table>
      </div>
    </div>
  </div>
</app-page-body>
